// extracted by mini-css-extract-plugin
module.exports = {"typeahead":"AddressTypeAhead--typeahead--1aMVg"};